module.exports = __webpack_public_path__ + "static/p3.501419d4.jpg";